import React from 'react'
import FormControl from '@material-ui/core/FormControl';
import Button from '@material-ui/core/Button';
import { ValidatorForm, TextValidator} from 'react-material-ui-form-validator';
import axios from 'axios';
import { confirmAlert } from 'react-confirm-alert';
import '../css/css/react-confirm-alert.css'; 
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';
export default function CallBackForm(props){

    const loadUserClassAPI = ()=>{
        let formData = new FormData();
        const callbackFields = {
            Name: props.values.name,
            PhoneNumber: props.values.mobilePhone,
            Email: props.values.email,
            ICP: props.values.icp,
            Address: props.values.address
        }
        formData.append('callback',JSON.stringify(callbackFields))
        axios.post("/home/requestCallBackFormHandler",formData
                ).then(res=>{
                    let result = res.data
                   // console.log(result)
                    if(result.success === true){
                        //load alert with successful message or redirection?
                        alertMessage('Thanks! ',res.data.message)
                    }else{
                        alertMessage('Oops, something went wrong',"Submission error, please try again.")
                    }
               
                }).catch(function (error) {
                    console.log(error);
                  })
                
            
           
        
      }
      const refreshPage =()=>{
        window.location.reload();
      }
      const alertMessage=(messageTitle,message)=>{
        return confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className='custom-ui react-confirm-alert-body' id="successCallbackAlert">
                      <h1>Thanks!</h1>
                      <p>One of our team will give you a call back soon.</p>
                      <button onClick={() => { onClose();refreshPage();
                        }}><CloseOutlinedIcon></CloseOutlinedIcon></button>
                    </div>
                  );
            },
            closeOnEscape: false,
            closeOnClickOutside: false,
           });
     }
   
        return (
            <div className="callbackform">
                <ValidatorForm  
                onSubmit={loadUserClassAPI} 
                autoComplete='off' 
                // noValidate={true}
                noValidate
                // onError={errors => console.log(errors)}
                >
                <FormControl component="fieldset" id="callbackFormFieldset">
                <div style={{minWidth:"300px",display:'flex',flexDirection:"column"}}>
                
                    <TextValidator
                    autoComplete='off' 
                    fullWidth 
                    autoFocus 
                    required 
                    validators={['required']}
                    errorMessages={['Please enter your name']}
                    style={{margin:'0 0 0 2rem'}} 
                    name="Name" label="Name" variant="standard" margin="normal"  value={props.values.name} onChange={props.handleChange('name')}/>
                    <TextValidator 
                    type="number"
                    fullWidth 
                    autoComplete='off' 
                    required
                    validators={['required']}
                    errorMessages={['Please enter your mobile number']}
                    style={{margin:'0 0 0 2rem'}} 
                    name="mobile phone" 
                    label="Mobile Phone" 
                    variant="standard" margin="normal"  
                    value={props.values.mobilePhone} 
                    onChange={props.handleChange('mobilePhone')}/>
              
                    <TextValidator
                    required
                    style={{margin:'0 0 1.3rem 2rem'}} 
                    label="Email"
                    onChange={props.handleChange('email')}
                    name="email"
                    value={props.values.email}
                    validators={['required', 'isEmail']}
                    errorMessages={['This field is required', 'Email is not valid']}
                />
                    <Button variant="contained" type="submit" style={{width:"100px",margin:'0 0 1.3rem 2rem'}} id="nextButton" >
                            Call me
                    </Button>
                    </div>
                </FormControl>
                </ValidatorForm>
            </div>
        )
    
}
